import React from "react";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmployeeReport, filterEmployeeReport } from '../../../Slices/employeereportslice';
import { selectReport } from "../../../Slices/employeereportslice";
import ClientsReportFilter from "../../../components/ClientsReportFilter";
import { setLoader } from "../../../Slices/loaderSlice";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";




const EmployeeReport = () => {

  const today = dayjs();
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const data = useSelector(selectReport);

  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
 

  const userid = loginUser.id.toString();
  const calculateTotalDuration = () => {
    let totalSeconds = data?.reduce((acc, data) => {
      const duration = data.duration;
      const match = duration?.match(/^(\d{2}):(\d{2}):(\d{2})$/); // This matches HH:MM:SS format

      if (match) {
        const hours = parseInt(match[1]); // Get hours from match[1]
        const minutes = parseInt(match[2]); // Get minutes from match[2]
        const seconds = parseInt(match[3]); // Get seconds from match[3]

        // Convert to total seconds and accumulate
        return acc + (hours * 3600) + (minutes * 60) + seconds;
      }

      return acc; // If no match, return accumulator as is
    }, 0);

    // Convert total seconds into hours, minutes, and seconds
    const totalHours = Math.floor(totalSeconds / 3600); // Total hours
    const remainingMinutes = Math.floor((totalSeconds % 3600) / 60); // Remaining minutes
    const remainingSeconds = totalSeconds % 60; // Remaining seconds

    // Return total duration in HH:MM:SS format
    return `${totalHours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };
  const getISTRangeTimestamps = (fromDate, toDate) => {
    const istStartDate = new Date(fromDate);
    const istEndDate = new Date(toDate);
    istStartDate.setHours(0, 0, 0, 0);
    istEndDate.setHours(23, 59, 59, 999);
    const startDateUTC = new Date(istStartDate.getTime());
    const endDateUTC = new Date(istEndDate.getTime());

    const startTimestamp = startDateUTC.getTime().toString();
    const endTimestamp = endDateUTC.getTime().toString();

    return {
      startTimestamp,
      endTimestamp,
    };
  };
  const { startTimestamp, endTimestamp } = getISTRangeTimestamps(today, today);
  const filters = {

    employeeName: userid,
    startDateTime: startTimestamp,
    endDateTime: endTimestamp,
    billable: null,
  };
  useEffect(() => {
  dispatch(setLoader(true));

  const startDateStr = dayjs(today).format('YYYY-MM-DD');
  const endDateStr = dayjs(today).format('YYYY-MM-DD');

  dispatch(filterEmployeeReport({ startDate: startDateStr, endDate: endDateStr }));
  dispatch(fetchEmployeeReport(filters)).then(() => {
    dispatch(setLoader(false));
  });

}, [userid]);
  const PageChange = (page) => {
    setCurrentPage(page);
  };


  const columns = [

    {
      title: "Client Name",
      dataIndex: "clientName",
    },

    {
      title: "Service",
      dataIndex: "service",
    },
    {
      title: "Task",
      dataIndex: "taskType",
    },
    {
      title: "Billable",
      dataIndex: "billable",
      render: (text, record) =>
        (record.taskType === "Email" || record.taskType === "Processing") ? "Yes" : "No",
      sorter: (a, b) => {
        const aVal = (a.taskType === "Email" || a.taskType === "Processing") ? 1 : 0;
        const bVal = (b.taskType === "Email" || b.taskType === "Processing") ? 1 : 0;
        return aVal - bVal;
      },
    },
    {
      title: "Request ID",
      dataIndex: "requestIds",
      sorter: (a, b) => a?.requestId?.length - b?.requestId?.length,
    },
    {
      title: "Start Date & Time",
      dataIndex: "startTime",
      sorter: (a, b) => a?.startTime - b?.startTime, 
      render: (text, record) => {
        const formattedDate = dayjs(parseInt(record.startTime));
        return formattedDate.isValid() ? formattedDate.format("DD/MM/YYYY hh:mm A") : "N/A";
      },
    },
    {
      title: "End Date & Time",
      dataIndex: "endTime",
      sorter: (a, b) => a?.endTime - b?.endTime, 
      render: (text, record) => {
        const formattedDate = dayjs(parseInt(record.endTime));
        return formattedDate.isValid() ? formattedDate.format("DD/MM/YYYY hh:mm A") : "N/A";
      },
    }
    ,
    {
      title: "Duration",
      dataIndex: "duration",
      sorter: (a, b) => a?.requestId?.length - b?.requestId?.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a?.status?.length - b?.status?.length,
    },
  ];
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <ClientsReportFilter PageChange={PageChange} />
          <div className="row mt-20px">
            <CustomGridTable
              Id="employee-report-table"
              style={{ overflowX: "auto" }}
              columns={columns}
              dataSource={data}
                rowKey="_id"
              size="small"
              pagination={{
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
                pageSize: 10,
                position: ['bottomRight'],
              }}
              scroll={{ x: 1000 }}
              footer={() => <div>
                <strong>Total Duration: </strong> {calculateTotalDuration()}
              </div>}
            />
          </div>
        </div>
      </div>

    </>
  );
};

export default EmployeeReport;
